import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const ReduceAbsenteeism4 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="reduceAbsenteeism" section="automation">
        <div className='TextGroup Satellite'>
            <SatelliteTopics t={props.t} prefix="reduceAbsenteeism:automation" noGroupTitle tag="h3" first noPadBottom />
        </div>
    </ServiceSection>
);

export default ReduceAbsenteeism4;
